import { itixCartController } from '@x-com/pwitixcomm/tslib/itix.cart.ts'
import Alpine from 'alpinejs'

const setValid = (form: HTMLFormElement, valid: boolean, validOpts?: { id: string; price: string }) => {
    const isValid = valid && validOpts
    const priceInput = form.querySelector<HTMLDivElement>('[data-qpark-prijs]')
    const qparkIdInput = form.querySelector<HTMLInputElement>('input[name="qpark_qparkid"]')

    if (!priceInput || !qparkIdInput) {
        return
    }

    if (isValid) {
        qparkIdInput.value = validOpts.id
        priceInput.dataset.qparkPrijs = validOpts.price
        priceInput.querySelector('input')!.value = validOpts.price
            ? '€ ' + Number(validOpts.price).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : ''
        priceInput.classList.remove('hide')
    } else {
        qparkIdInput.value = ''
        priceInput.dataset.qparkPrijs = ''
        priceInput.querySelector('input')!.value = ''
        priceInput.classList.add('hide')
    }

    const btn = form.querySelector('button[type=submit]')

    if (btn) {
        if (isValid) {
            btn.querySelector('span').textContent = btn.dataset.qparkOrderText
        } else {
            btn.querySelector('span').textContent = btn.dataset.qparkCheckText
        }
    }
}

export const initOrderArticle = () => {
    Alpine.data('orderArticle', ({ qpark, successMsg, dateRequiredMsg, pricedFetchedMsg }) => ({
        init() {
            if (this.$el instanceof HTMLFormElement) {
                const form = this.$el

                if (qpark) {
                    form.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select').forEach((input) => {
                        input.onchange = () => {
                            setValid(form, false)
                        }
                    })
                }

                form.onsubmit = async (e) => {
                    e.preventDefault()
                    form.querySelectorAll('.alert--error, .alert--success').forEach((el) => el.remove())

                    if (qpark) {
                        const entries = Object.fromEntries(new FormData(form)) as { [x: string]: string }

                        if (!entries.qpark_datumtijd) {
                            form.prepend(createErrorElement(dateRequiredMsg, 'error'))
                            return
                        }

                        const fromDate = new Date(entries.qpark_datumtijd)
                        const toDate = new Date(fromDate)
                        toDate.setHours(toDate.getHours() + 6)

                        if (!entries.qpark_qparkid) {
                            const formData = new FormData()

                            formData.append('artikel_id', entries.artikel_id)
                            formData.append('qpark_datum', fromDate.toISOString().split('T')[0])
                            formData.append('qpark_tijd_van', ('0' + fromDate.getHours()).slice(-2) + ':' + ('0' + fromDate.getMinutes()).slice(-2))
                            formData.append('qpark_tijd_tot', ('0' + toDate.getHours()).slice(-2) + ':' + ('0' + toDate.getMinutes()).slice(-2))

                            const data = await itixCartController.qparkAvailability(formData)

                            if (data.status === 'OK') {
                                form.prepend(createErrorElement(pricedFetchedMsg, 'info'))
                            } else {
                                form.prepend(createErrorElement(data.message, 'error'))
                            }

                            setValid(
                                form,
                                data.status === 'OK',
                                data.status === 'OK' ? { id: data.message[0].id, price: data.message[0].totalAmount } : undefined
                            )
                        } else {
                            const priceInput = form.querySelector<HTMLDivElement>('[data-qpark-prijs]')
                            const price = priceInput!.dataset.qparkPrijs

                            const formData = new FormData()

                            formData.append('articleId', entries.artikel_id)
                            formData.append('amount', entries.amount)
                            formData.append('price', price)
                            // formData.append('details[relatedBookingId]', '')
                            formData.append('details[qpark_qparkid]', entries.qpark_qparkid)
                            formData.append('details[qpark_kenteken]', entries.qpark_kenteken)
                            formData.append('details[qpark_land]', entries.qpark_land)
                            formData.append('details[qpark_kenteken]', entries.qpark_kenteken)
                            formData.append('details[qpark_datum]', fromDate.toISOString().split('T')[0])
                            formData.append(
                                'details[qpark_tijd_van]',
                                ('0' + fromDate.getHours()).slice(-2) + ':' + ('0' + fromDate.getMinutes()).slice(-2)
                            )
                            formData.append(
                                'details[qpark_tijd_tot]',
                                ('0' + toDate.getHours()).slice(-2) + ':' + ('0' + toDate.getMinutes()).slice(-2)
                            )

                            const data = await itixCartController.addArticle(formData)

                            if (data.status === 'OK') {
                                form.prepend(createErrorElement(successMsg, 'info'))
                                setValid(form, false)
                            } else {
                                form.prepend(createErrorElement(data.message, 'error'))
                            }
                        }
                    } else {
                        const data = await itixCartController.addArticle(new FormData(form))

                        if (data.status === 'OK') {
                            form.prepend(createErrorElement(successMsg, 'info'))
                        } else {
                            form.prepend(createErrorElement(data.message, 'error'))
                        }
                    }
                }
            }
        },
    }))
}

const createErrorElement = (message: string, type: 'error' | 'info') => {
    const errorElement = document.createElement('p')
    errorElement.classList.add('alert')
    errorElement.classList.add(type === 'error' ? 'alert--error' : 'alert--success')
    errorElement.innerHTML = message
    return errorElement
}
